import { useState } from 'react';
import { hostUrl, UseUrlManagerCleanUrl } from "../../../../../utils/url-manager";
import {read_cookie} from "sfcookies";

type PanelType = {
    loadingData: boolean,
    loadingError: string,
    subscriptionData: any
}

export const useSubscriptionDataPanelLoader: (subscriptionId: string) => PanelType = (subscriptionId: string): PanelType => {
    const [loadingData, setLoadingData] = useState<boolean>(true);
    const [loadingError, setLoadingError] = useState<string>('');
    const [subscriptionData, setSubscriptionData] = useState<any>();

    if (subscriptionData === undefined) {
        const url: string = UseUrlManagerCleanUrl({ url: hostUrl + 'hq/customer/account/subscription/stripe/data' });
        const token: string = read_cookie('auth');
        const request: Request = new Request(url, {
            method: 'POST',
            body: JSON.stringify( { id: subscriptionId } ),
            headers: new Headers({
                'Content-Type': 'application/json',
                'token': token,
            })
        });
        fetch(request)
            .then( (response: Response): Promise<any> => {
                return response.json();
            } )
            .then( (data: any): void => {
                setLoadingData(false);
                if (data?.status === 'success') {
                    setSubscriptionData(data?.data);
                }
                if (data?.status === 'error') {
                    setLoadingError(data?.message);
                }
            } )
            .catch( (error: Error): void =>  {
                console.log(error);
            } );
    }

    return { loadingData, loadingError, subscriptionData }

}